import { useNotifications } from './NotificationContext';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { createFaviconWithBadge } from './NotificationContext';

// Helper to remove any leading (n) from the title
const cleanTitle = (title) => title.replace(/^\(\d+\)\s*/, '');

export default function BadgeManager() {
  const { hasUnreadNotifications } = useNotifications();
  const location = useLocation();
  const observerRef = useRef(null);

  useEffect(() => {
    const titleEl = document.querySelector('title');
    if (!titleEl) return;

    const applyBadge = () => {
      observerRef.current?.disconnect();

      const baseTitle = cleanTitle(titleEl.textContent);

      if (hasUnreadNotifications) {
        titleEl.textContent = `(1) ${baseTitle}`;
      } else {
        titleEl.textContent = baseTitle;
      }

      createFaviconWithBadge(hasUnreadNotifications);

      observerRef.current?.observe(titleEl, { childList: true });
    };

    observerRef.current = new MutationObserver(applyBadge);
    observerRef.current.observe(titleEl, { childList: true });

    applyBadge();

    return () => {
      observerRef.current?.disconnect();
    };
  }, [hasUnreadNotifications, location.pathname]);

  return null;
}
